export function isMobileApp() {
   return /iFixitMobileApp/i.test(navigator.userAgent);
}

export function isAndroidMobileApp() {
   return /iFixitMobileApp\/android/i.test(navigator.userAgent);
}
